import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export function NotFoundPage() {
  const { t } = useTranslation('common')
  return (
    <div className="flex flex-col gap-3">
      <h1 className="text-2xl font-semibold">{t('notFound.title')}</h1>
      <p className="text-sm text-muted-foreground">
        {t('notFound.description')}{' '}
        <Link className="underline underline-offset-4" to="/">
          {t('notFound.back')}
        </Link>
      </p>
    </div>
  )
}
